<template>
  <v-app>
    <toolbars />

    <navigation-drawer />

    <v-content>
      <v-container
        grid-list-md
        fluid
      >
        <router-view v-if="$route.name !== 'dashboard'" />
        <!-- end -->
        <forcasting v-else />
      </v-container>
    </v-content>

    <v-footer
      inset
      absolute
      app
    >
      <span class="px-3 caption">
        &copy; {{ new Date().getFullYear() }} Powered by Metadata Computer Systems
      </span>
    </v-footer>

    <snackbar />
    <!-- end snackbar -->
  </v-app>
</template>

<script>
import Toolbars from '@/components/Toolbars/Toolbars'
import NavigationDrawer from '@/components/Navigation/NavigationDrawer'
import Snackbar from '@/components/Utilities/Snackbar'
import Forcasting from './forcasting'
export default {
  components: {
    Toolbars,
    NavigationDrawer,
    Forcasting,
    Snackbar
  }
}
</script>
